import React, { FC } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, TextFieldProps } from '@mui/material';
import { Search } from 'src/components/Forms/FormInputs/styled';

interface SearchInputProps {
  value: string;
  onDelete: () => void;
}

export const SearchInput: FC<SearchInputProps & TextFieldProps> = ({
  value,
  onDelete,
  ...props
}) => {
  return (
    <Search
      {...props}
      autoComplete="off"
      value={value}
      InputProps={{
        startAdornment: <SearchIcon />,
        endAdornment: value && (
          <IconButton onClick={onDelete}>
            <ClearIcon />
          </IconButton>
        ),
      }}
    />
  );
};
